import styled, { useMediaQuery, mediaQuery, css, theme } from 'academy-common-lib/utils/Styling';
import H1 from 'UIComponents/elements/headings/H1';
import H4 from 'UIComponents/elements/headings/H4';
import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error Could not find a declaration file for module
import blobsImageUrl from 'bender-url!../../../images/storefront-header-blobs.svg';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeadingContainer = styled(UIFlex).withConfig({
  displayName: "Heading__HeadingContainer",
  componentId: "sc-1dmf1ap-0"
})(["height:180px;background:", ";background-image:url(", "),linear-gradient( to right,", ",", " );background-position:center center;background-repeat:no-repeat;background-size:auto 100%;color:", ";text-align:center;padding:16px;", ""], theme.colors.CALYPSO, blobsImageUrl, theme.colors.CALYPSO_DARK, theme.colors.CALYPSO, theme.colors.OLAF, mediaQuery('mobile', css(["height:auto;padding:8px;background-image:none;"])));
const SubHeaderTitle = styled.span.withConfig({
  displayName: "Heading__SubHeaderTitle",
  componentId: "sc-1dmf1ap-1"
})(["font-size:18px;font-weight:400;"]);
const HeadingNav = ({
  title,
  subtitle,
  leftContent,
  rightContent
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(HeadingContainer, {
    align: "center",
    direction: isMobile ? 'column' : 'row',
    children: [/*#__PURE__*/_jsx(UIBox, {
      basis: 0,
      grow: 1,
      children: leftContent
    }), /*#__PURE__*/_jsx(UIBox, {
      basis: 0,
      grow: 1,
      children: isMobile ? /*#__PURE__*/_jsx(H4, {
        className: "m-bottom-0",
        children: title
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H1, {
          className: 'm-bottom-3 p-top-4',
          children: title
        }), /*#__PURE__*/_jsx(SubHeaderTitle, {
          children: subtitle
        })]
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      basis: 0,
      grow: 1,
      children: rightContent
    })]
  });
};
export default HeadingNav;